import React from 'react';
import { useClerk, useAuth } from '@clerk/react';
import './Login.css';

const Login: React.FC = () => {
  const { openSignIn, openSignUp, signOut } = useClerk();
  const { isSignedIn } = useAuth();

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Ops Email</h1>
          <p>Sign in to your account</p>
        </div>

        <button
          type="button"
          className="clerk-button"
          onClick={async () => {
            if (isSignedIn) await signOut();
            openSignIn({ afterSignInUrl: window.location.href });
          }}
        >
          Sign in with Clerk
        </button>

        <button
          type="button"
          className="clerk-button"
          onClick={async () => {
            if (isSignedIn) await signOut();
            openSignUp({ afterSignUpUrl: window.location.href });
          }}
        >
          Sign up with Clerk
        </button>

        <div className="login-footer">
          <p>Contact your administrator for account access</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
